// extracted by mini-css-extract-plugin
export default {"container":"style_container__OCYjN","exBox":"style_exBox__TB1sw","tableDetail":"style_tableDetail__MIuBP","dimentions":"style_dimentions__FKbpb"};